import * as React from "react";
import styled, { css } from "styled-components";
import { useEffect } from "react";
import { Button, Alert, Modal, Col, Row } from "components/bootstrap";
import { Spinner, ClipboardButton, Icon, ModalButtonToolbar } from "components/common";
import useAIReport from "security-app/components/Investigations/AIReport/hooks/useAIReport";
import Markdown from "components/common/Markdown";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { downloadBLOB } from "util/FileDownloadUtils";
import SatisfactionSurvey from "security-app/components/Investigations/AIReport/SatisfactionSurvey";
import AIQuotaInfo from "ai/common/AIQuotaInfo";
import useAIQuotaStatus from "ai/hooks/useAIQuotaStatus";
const Footer = styled(Row)`
  display: flex;
`;
const DisclaimerContainer = styled(Col)`
  display: flex;
  align-items: center;
`;
const DisclaimerText = styled.i`
  margin-left: 30px;
  font-size: 10px;
  color: gray;
`;
const Wrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.md};
    flex-direction: column;
    border: 1px solid ${theme.colors.cards.border};
    border-radius: ${theme.spacings.sm};
    padding: ${theme.spacings.md} ${theme.spacings.lg};
    margin-bottom: ${theme.spacings.md};
  `
);
const AIReportModalContent = ({ onClose, investigation }) => {
  const { data: quotaData, isLoading: quotaIsLoading } = useAIQuotaStatus();
  const loadAIReportDataEnabled = !((quotaData == null ? void 0 : quotaData.remaining) === 0) && !quotaIsLoading;
  const { data, isFetching, isSuccess, isFetched, isError, error } = useAIReport(
    investigation.id,
    loadAIReportDataEnabled
  );
  const sendTelemetry = useSendTelemetry();
  useEffect(() => {
    if (isFetched && isSuccess) {
      sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_REPORT_BY_AI.GET_REPORT_SUCCESS, {});
    }
    if (isFetched && !isSuccess && isError) {
      sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_REPORT_BY_AI.GET_REPORT_FAILED, {});
    }
  }, [isSuccess, isFetched, isError, sendTelemetry]);
  const AI_REPORT_DISCLAIMER = "AI-generated content may contain inaccuracies or be misleading. Please verify all information independently.";
  const onDownload = () => {
    const finalReport = `**Investigation Name: ${investigation.name}**
===============================${data}


${AI_REPORT_DISCLAIMER}`;
    downloadBLOB(finalReport, { fileName: `AI_Report_${investigation.name}.txt`, contentType: "text/plain" });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement("h3", null, /* @__PURE__ */ React.createElement("i", null, investigation.name), " - AI Report")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { mdPush: 8, md: 4, xsPush: 7, xs: 5 }, /* @__PURE__ */ React.createElement(AIQuotaInfo, null))), isFetching ? /* @__PURE__ */ React.createElement(Spinner, { text: "Generating AI Report..." }) : /* @__PURE__ */ React.createElement("div", null, data && !isError && /* @__PURE__ */ React.createElement(Markdown, { text: data }), isError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "" }, error.message))), !isFetching && loadAIReportDataEnabled && /* @__PURE__ */ React.createElement(Footer, null, /* @__PURE__ */ React.createElement(DisclaimerContainer, { md: 7 }, /* @__PURE__ */ React.createElement(DisclaimerText, null, AI_REPORT_DISCLAIMER)), /* @__PURE__ */ React.createElement(Col, { md: 5 }, /* @__PURE__ */ React.createElement(SatisfactionSurvey, null)))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(ModalButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, "Close"), /* @__PURE__ */ React.createElement(
    ClipboardButton,
    {
      title: "Copy Report",
      bsStyle: "info",
      text: data,
      disabled: isFetching || isError || !loadAIReportDataEnabled,
      buttonTitle: "Copy Report"
    }
  ), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onDownload, disabled: isFetching || isError || !loadAIReportDataEnabled }, /* @__PURE__ */ React.createElement(Icon, { name: "note_add", type: "regular" }), " Download Report"))));
};
export default AIReportModalContent;
